export const APP_URL = {
    AUTHENTICATION: {
        REGISTER: '/registro',
        LOGIN: '/login',
        RECOVERY: '/recuperar-contrasenia'
    },
    QUIZ: {
        HOME: '/home',
        SELECT: '/p/seleccionar',
        COURSES: '/p/cursos',
        MESSAGE: '/p/mensaje-inicial'
    },
    DASHBOARD: {
        HOME: '/p/dashboard'
    }
}